export default __webpack_public_path__ + "static/media/payment-auth-sk-dark.27e622ac.png";